import { lazyWithRetry as lazy } from '@utils/lazyWithRetry';
import { RouteConfig } from '@routes/types';
import HomeWrapper from '@page/HomeWrapper';

const ContractorPortalHome = lazy(
  () => import('@component/ContractorPortal/ContractorPortalHome')
);
const ContractorPortalAdmin = lazy(
  () => import('@component/ContractorPortal/ContractorPortalAdmin')
);
const ContractorPortalPayerInvitations = lazy(
  () => import('@component/ContractorPortal/ContractorPortalPayerInvitations')
);
const ContractorPortalContractorInfo = lazy(
  () => import('@component/ContractorPortal/ContractorPortalContractorInfo')
);
const ContractorPortalAuditLogs = lazy(
  () => import('@component/ContractorPortal/ContractorPortalAuditLogs')
);
const ContractorPortalNotifications = lazy(
  () => import('@component/ContractorPortal/ContractorPortalNotifications')
);
const ContractorPortalStandingOrders = lazy(
  () => import('@component/ContractorPortal/ContractorPortalStandingOrders')
);
const ContractorPortalAssignmentScreen = lazy(
  () => import('@component/ContractorPortal/ContractorPortalAssignmentScreen')
);
const PageNotFound = lazy(() => import('@component/PageNotFound/PageNotFound'));
const IconsWrapper = lazy(() => import('@page/IconsWrapper'));
const SomethingWentWrong = lazy(
  () => import('@component/SomethingWentWrong/SomethingWentWrong')
);
const NoAuthorization = lazy(
  () => import('@component/NoAuthorization/NoAuthorization')
);
const ConfigWrapper = lazy(() => import('@page/ConfigWrapper'));

export const contractorPortalRoutes: RouteConfig[] = [
  {
    path: '/',
    element: HomeWrapper,
    children: [
      {
        path: '',
        element: ContractorPortalHome,
      },
      {
        path: 'admin/users',
        element: ContractorPortalAdmin,
      },
      {
        path: 'admin/payer-invitations',
        element: ContractorPortalPayerInvitations,
      },
      {
        path: 'contractors/information',
        element: ContractorPortalContractorInfo,
      },
      {
        path: 'contractors/standing-orders',
        element: ContractorPortalStandingOrders,
      },
      {
        path: 'contractors/audit-logs',
        element: ContractorPortalAuditLogs,
      },
      {
        path: 'contractors/notifications',
        element: ContractorPortalNotifications,
      },
      {
        path: 'assignment-screen',
        element: ContractorPortalAssignmentScreen,
      },
    ],
  },
  {
    path: 'icons',
    element: IconsWrapper,
  },
  {
    path: 'configs',
    element: ConfigWrapper,
  },
  {
    path: 'wrong',
    element: SomethingWentWrong,
  },
  {
    path: 'no-authorization',
    element: NoAuthorization,
  },
  {
    path: '*',
    element: PageNotFound,
  },
];
